import React, {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {AgentReportFilter} from './agent-data.store';
import stickySurfaceStyles from './refer-earn-sticky-surface.module.scss';
import {useStickyActive} from './use-sticky-active';

interface MyDataFilterTabsProps {
  activeFilter: AgentReportFilter;
  onFilterChange: (filter: AgentReportFilter) => void;
}

const filters: AgentReportFilter[] = [
  'yesterday',
  'today',
  'threeDays',
  'week',
  'fifteenDays',
  'month',
];

const MyDataFilterTabs = ({
  activeFilter,
  onFilterChange,
}: MyDataFilterTabsProps) => {
  const {t} = useTranslation();
  const {active: stickyActive, sentinelRef} = useStickyActive();
  const buttonRefs = useRef<
    Partial<Record<AgentReportFilter, HTMLButtonElement>>
  >({});

  useEffect(() => {
    buttonRefs.current[activeFilter]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [activeFilter]);

  return (
    <>
      <span ref={sentinelRef} aria-hidden="true" className="block h-px" />
      <section
        className={[
          stickyActive ? stickySurfaceStyles.stickySurface : '',
          stickyActive ? stickySurfaceStyles.fullWidthDataControlsSurface : '',
          'sticky top-[3.0625rem] z-20 -mx-3 mt-1 bg-transparent px-3 py-2',
        ].join(' ')}>
        <div className="flex h-8 w-full items-center gap-2 overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {filters.map(key => {
            const active = key === activeFilter;
            return (
              <button
                type="button"
                key={key}
                ref={element => {
                  if (element) {
                    buttonRefs.current[key] = element;
                  }
                }}
                onClick={() => onFilterChange(key)}
                className={[
                  'flex h-8 shrink-0 items-center justify-center rounded-[0.625rem] border-0 px-3 text-center text-[0.75rem] font-normal leading-none tracking-[-0.01875rem] text-black [touch-action:manipulation]',
                  active ? 'bg-[#FB6B0B]' : 'bg-[rgba(255,255,255,0.06)]',
                ].join(' ')}>
                {t(`invitation.myData.filters.${key}`)}
              </button>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default MyDataFilterTabs;
